import { Fragment } from "react";

export function TitleLines({ lines }: { lines: string[] }) {
    return (
        <>
            {lines.map((line, index) => (
                <Fragment key={`${line}-${index}`}>
                    {index > 0 ? <br /> : null}
                    {line}
                </Fragment>
            ))}
        </>
    );
}

export function ChipText({ text }: { text: string }) {
    return (
        <>
            {text.split("\n").map((line, index) => (
                <Fragment key={`${line}-${index}`}>
                    {index > 0 ? <br /> : null}
                    {line}
                </Fragment>
            ))}
        </>
    );
}
